import { listEmbedEntryPoint } from '@jira/spa-apps__business-list-embed/src/listEmbedEntryPoint.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessListEmbedRoute } from '@jira/router-routes__business-list-routes/src/jiraBusinessListEmbedRoute.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { getRouteReporting } from '@jira/router-routes__issue-navigator-entries/src/common/getRouteReporting.tsx';
import { EmbedIssueNavigatorSkeleton } from '@jira/platform__skeletons/src/ui/issue-navigator/components/embed-app.tsx';
import { issueNavigatorEmbedPageEntryPoint } from '@jira/router-routes__issue-navigator-entries/src/ui/index.tsx';
import { getCommonProjectResources } from '@jira/router-routes__issue-navigator-entries/src/common/getCommonProjectResources.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const listEmbedPageEntryPoint = createChromelessEntryPoint({
	main: listEmbedEntryPoint,
});

export const jiraBusinessListEmbedRouteEntry: Route = createEntry(
	jiraBusinessListEmbedRoute,
	() => ({
		group: 'classic-business',
		ufoName: fg('jira_list_nin_merge') ? 'jwm-list-nin-embed' : 'jwm.list-embed-view',

		meta: fg('jira_list_nin_merge')
			? {
					capability: NIN_NEW_ISSUE_NAVIGATOR,
					reporting: getRouteReporting(),
				}
			: undefined,

		layout: chromelessLayout,
		skeleton: fg('jira_list_nin_merge') ? EmbedIssueNavigatorSkeleton : ThemedLazySkeleton,

		entryPoint: () => {
			if (fg('jira_list_nin_merge')) {
				return issueNavigatorEmbedPageEntryPoint;
			}
			return listEmbedPageEntryPoint;
		},

		resources: fg('jira_list_nin_merge') ? getCommonProjectResources() : getProjectViewResources(),
		supportsProjectTheme: fg('jira_list_nin_merge') ? undefined : 'full',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
